import React, {useState, useEffect, useRef} from "react";
import { GoogleMap, Marker, LoadScript } from "@react-google-maps/api";
import { GOOGLE_MAP_KEY } from "consts/env";

const libraries = ["places"];

export default function Mapa(props) {
    const { lat, lng, style } = props;
    const center = {
        lat: lat
            ? typeof lat === "number"
                ? lat
                : parseFloat(lat)
            : -34.6036844,
        lng: lng
            ? typeof lng === "number"
                ? lng
                : parseFloat(lng)
            : -58.3815591,
    };

    const containerStyle = {
        width: "100%",
        height: "100%",
        ...style,
    };

    
    const mapRef = useRef(null);
    const [markerPos, setMarkerPos] = useState(center);

    useEffect(() => {
        const c = center;
        setMarkerPos(c);
        if (mapRef.current && c && c.lat != null && c.lng != null) {
            try {
                mapRef.current.panTo({ lat: Number(c.lat), lng: Number(c.lng) });
            } catch (e) {
                // ignore pan errors
            }
        }
    }, [center.lat, center.lng]);

    return (
        <LoadScript
            id="google-map-script"
            googleMapsApiKey={`${GOOGLE_MAP_KEY}`}
            libraries={libraries}
        >
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={14}
                onLoad={(map) => (mapRef.current = map)}
                onUnmount={() => (mapRef.current = null)}
            >
                <Marker position={center} />
            </GoogleMap>
        </LoadScript>
    );
}
